import { Drawer, DrawerHeader } from "@components/v2";

import { TableContent } from "./table-content";
import { type TableState } from "./types";

interface Props {
  index: number;
  tableState?: TableState;
  onClose: () => void;
  onTableStateChange: (tableState: TableState) => void;
}

export const TableDrawer = ({
  index,
  tableState,
  onClose,
  onTableStateChange,
}: Props) => {
  return (
    <Drawer
      bodyClassName="bg-v2-primary flex flex-col gap-6 overflow-hidden"
      size={`calc(100% - 110px - ${36 * index}px)`}
      isOpen={tableState !== undefined}
      onClose={onClose}
    >
      {tableState && (
        <Content
          tableState={tableState}
          onClose={onClose}
          onTableStateChange={onTableStateChange}
        />
      )}
    </Drawer>
  );
};

const Content = ({
  tableState,
  onClose,
  onTableStateChange,
}: {
  tableState: TableState;
  onClose: () => void;
  onTableStateChange: (tableState: TableState) => void;
}) => {
  const lastBreakdownFilter =
    tableState.breakdownFilters[tableState.breakdownFilters.length - 1];

  return (
    <>
      <div>
        <DrawerHeader onClose={onClose}>
          {lastBreakdownFilter?.value ?? "Sales Table"}
        </DrawerHeader>
      </div>
      <TableContent
        isMaximized
        tableState={tableState}
        onTableStateChange={onTableStateChange}
      />
    </>
  );
};
